var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video-panorama", class: { hide: _vm.ended } },
    [
      _vm.notAvailable
        ? _c("div", { staticClass: "not-available" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("video360.notAvailable")) + "\n  "),
          ])
        : _vm.video.platform === "youtube"
        ? _c("youtube", {
            ref: "youtube",
            attrs: {
              width: "100%",
              height: "100%",
              "video-id": _vm.video.videoId,
              "player-vars": _vm.youtubePlayerVars,
            },
            on: { ready: _vm.onYouTubeReady, ended: _vm.onYouTubeEnd },
          })
        : _vm.video.platform === "vimeo"
        ? _c("vue-vimeo-player", {
            ref: "vimeo",
            attrs: {
              "player-width": _vm.vimeoPlayerVars.playerWidth,
              "player-height": _vm.vimeoPlayerVars.playerHeight,
              autoplay: true,
              controls: true,
              "video-id": _vm.video.videoId,
            },
            on: { ready: _vm.onVimeoReady, ended: _vm.onEnd },
          })
        : _c("iframe", {
            attrs: {
              src: _vm.video.videoUrl,
              width: "100%",
              height: "100%",
              frameBorder: "0",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }